import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import apiService from '../services/api';
import { getProductDiscountPct, applyDiscount } from '../utils/discountUtils';

/**
 * Fetches the current user's discount eligibility and returns helpers for
 * calculating per-product discounts.
 */
export function useUserDiscountEligibility() {
  const { currentUser, isAuthenticated } = useAuth();
  const [isRoyalSubscriber, setIsRoyalSubscriber] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setLoaded(true);
      return;
    }
    apiService.subscriptions.getMy()
      .then(res => {
        const sub = res.data?.data;
        setIsRoyalSubscriber(sub?.tier === 'royal' && sub?.status === 'active');
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [isAuthenticated]);

  const isFriendsAndFamily = currentUser?.isFriendsAndFamily || false;

  function getDiscountPct(product) {
    return getProductDiscountPct(product, isRoyalSubscriber, isFriendsAndFamily);
  }

  function getDiscountedPrice(product, originalPrice) {
    return applyDiscount(originalPrice, getDiscountPct(product));
  }

  return { isRoyalSubscriber, isFriendsAndFamily, getDiscountPct, getDiscountedPrice, loaded };
}
